import { ROUTE_TO_PRODUCT_MAP, PRODUCT_SPORTSBOOK } from './sportsbook-constants.js';

/**
 * Translate a sportsbook path to a sportsbook product.
 * If the pathname is omitted or in a bad format, the product
 * "sportsbook" will be returned.
 *
 *
 * @example <caption>Usage:</caption>
 * const location = useLocation();
 * .....
 * const product = getProductFromPath(location.pathname);
 * .....
 *
 * @param {String} pathname (location.pathname)
 *
 * @returns {String} product
 */
export const getProductFromPath = pathname => {
	// Default to sportsbook
	if (!pathname || !pathname.includes('/')) {
		return PRODUCT_SPORTSBOOK;
	}

	const product = pathname.split('/')[1];
	const productRoute = '/'.concat(product);

	if (!ROUTE_TO_PRODUCT_MAP[productRoute]) {
		return PRODUCT_SPORTSBOOK;
	}

	return ROUTE_TO_PRODUCT_MAP[productRoute];
};
